import * as qs from 'qs';
import {API} from '../API';
import {AccountFormService} from './AccountFormService';
import {LocationService} from './LocationService';
import {NoteService} from './NoteService';
import {OptionService} from './OptionService';
import {PersonService} from './PersonService';

export class ContactService {

  constructor() {
    this.accountForm = new AccountFormService();
    this.location = new LocationService();
    this.note = new NoteService();
    this.option = new OptionService();
    this.person = new PersonService();
  }

  async getTableContacts(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getContacts(query, page, length);
  }

  async getContacts(query, page, length) {
    return (await API.getConnection())
      .get('contacts', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async saveContact(data) {
    let method = 'post';
    let url = 'contacts';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => {
        this.option.reset();
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }

  async getContact(id, archive = false) {
    return (await API.getConnection())
      .get(`contacts/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => {
        return API.handleError(error);
      });
  }

  async deleteContact(contact) {
    return (await API.getConnection())
      .delete(`contacts/${contact.id}`)
      .then(() => {
        this.option.reset();
        return null;
      })
      .catch(error => API.handleError(error));
  }

  async restoreContact(contact) {
    return (await API.getConnection())
      .put(`contacts/${contact.id}/restore`)
      .then(response => {
        this.option.reset();
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }

  async getCachedContacts() {
    return this.option.getCache('contacts', this.getContacts({}, 1, 1000));
  }

  async getCachedCustomers() {
    return this.option.getCache('customers', this.getContacts({filter: {customers: '1'}}, 1, 1000));
  }

  async getCachedTransporters() {
    return this.option.getCache('transporters', this.getContacts({filter: {transporters: '1'}}, 1, 1000));
  }
}
